'use client'

export function getLangFromUrl() {
  return window.location.pathname.split('/')[1]
}
